import { Dialog, Listbox } from '@headlessui/react'
import {
  ChevronDownIcon,
  MagnifyingGlassIcon,
} from '@heroicons/react/24/outline'
import Header from '../../../components/header'
import { RulesetsState } from '../hooks/use-rulesets'
import ImportData from './import-data'

type RulesetsHeaderProps = {
  state: RulesetsState
}

const RulesetsHeader = (props: RulesetsHeaderProps) => {
  const rulesetsState: RulesetsState = props.state

  const statusOptions = [
    { name: 'ALL', value: null },
    { name: 'ACTIVE', value: true },
    { name: 'INACTIVE', value: false },
  ]

  return (
    <>
      <Header>
        <div className="container w-full mx-auto">
          <div className="container mx-auto mb-6 text-3xl font-semibold text-white">
            Find a Rule Set
          </div>
          <div className="container flex items-center gap-2 px-6 py-2 mx-auto mb-6 bg-white rounded-full">
            <MagnifyingGlassIcon className="w-8 h-8 text-gray-500" />
            <input
              key="search-input"
              className="w-full m-2 text-lg outline-none"
              placeholder="Search Rule Sets"
              value={rulesetsState.query}
              onChange={(e) => rulesetsState.setQuery(e.target.value)}
            ></input>
          </div>
        </div>
      </Header>
      <div className="p-12 pt-6 pb-6">
        <div className="flex items-center justify-between py-6 border-b">
          <div className="relative">
            <div className="flex flex-row">
              <Listbox
                value={rulesetsState.stateId}
                onChange={(e) => {
                  rulesetsState.updateState(+e)
                }}
              >
                <div className="relative">
                  <Listbox.Button className="flex items-center justify-between px-4 py-2 mx-2 bg-white border rounded-md border-primary-blue min-w-64">
                    <div>
                      Filter by State:{' '}
                      <span className="pl-2 font-semibold uppercase text-primary-blue">
                        {
                          rulesetsState.states.find(
                            (s) => s.id === rulesetsState.stateId
                          )?.name
                        }
                      </span>
                    </div>
                    <ChevronDownIcon className="w-4 h-4 ml-8" />
                  </Listbox.Button>
                  <Listbox.Options className="absolute z-10 w-full h-64 p-2 mt-2 ml-2 overflow-auto bg-white rounded-md shadow-lg">
                    {rulesetsState.states &&
                      rulesetsState.states.map((state) => (
                        <Listbox.Option
                          key={`s-${state.id}`}
                          value={state.id}
                          className="p-2 uppercase border-b cursor-pointer last:border-b-0"
                        >
                          {state.name}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </div>
              </Listbox>
              <Listbox
                value={rulesetsState.filterByActive}
                onChange={(e) => {
                  rulesetsState.setFilterByActive(e)
                }}
              >
                <div className="relative">
                  <Listbox.Button className="flex items-center justify-between px-4 py-2 mx-2 bg-white border rounded-md border-primary-blue min-w-64">
                    <div>
                      Filter by Status:{' '}
                      <span className="pl-2 font-semibold uppercase text-primary-blue">
                        {
                          statusOptions.find(
                            (s) => s.value === rulesetsState.filterByActive
                          )?.name
                        }
                      </span>
                    </div>
                    <ChevronDownIcon className="w-4 h-4 ml-8" />
                  </Listbox.Button>
                  <Listbox.Options className="absolute z-10 w-full p-2 mt-2 ml-2 overflow-y-auto bg-white rounded-md shadow-lg">
                    {statusOptions.map((status, i) => (
                      <Listbox.Option
                        key={i}
                        value={status.value}
                        className="p-2 uppercase border-b cursor-pointer last:border-b-0"
                      >
                        {status.name}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </div>
              </Listbox>
            </div>
          </div>
          <div className="flex items-center gap-4 justify-ent">
            <button
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                rulesetsState.startImport()
              }}
              className="inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              IMPORT
            </button>
            <a
              href={rulesetsState.getExportLink()}
              className="inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              EXPORT
            </a>
            <button
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                rulesetsState.startNewRuleSet()
              }}
              className="inline-flex tracking-[0.07rem] justify-center items-center px-6 py-3 text-white border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              CREATE NEW RULE SET
            </button>
          </div>
        </div>
      </div>
      <Dialog
        open={rulesetsState.showImport}
        onClose={() => {
          if (!rulesetsState.importing) {
            rulesetsState.cancelImport()
          }
        }}
        className="fixed inset-0 z-10 overflow-y-auto"
      >
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
          <ImportData state={rulesetsState} />
        </div>
      </Dialog>
    </>
  )
}

export default RulesetsHeader
